import { Config } from 'config';
import { addParamsToUrl } from 'utils';

import { URL } from '../constants';
import { apiLoaderInstance } from '../instance';

import { CourseSubmissionPdfRequest } from './types';

export const downloadPdf = () => {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const fileName = Config.isLoginByGuestId
    ? '2d19f619-133f-4861-b5c7-f2936ae9a30d.pdf'
    : 'ae3698a0-c60c-4168-823e-5670269ec317.pdf';

  return apiLoaderInstance.get(`${origin}/pdfs/${fileName}`, {
    responseType: 'blob',
  });
};

export const downloadCourseSubmissionPdf = ({
  id,
  timezone,
}: CourseSubmissionPdfRequest) =>
  apiLoaderInstance.get(
    addParamsToUrl(URL.COURSE_SUBMISSIONS_CERTIFICATE_PDF.replace(':id', id), {
      timezone,
    }),
    { responseType: 'blob' }
  );
